export default __webpack_public_path__ + "static/media/facebookhumano.e969dd30.svg";